export default __webpack_public_path__ + "static/media/bck2.20821855.png";